const SESSION_VAR = 'testsession';

export class TestSession {
    /* STATIC */
    public static get (): TestSession {
        // Comprobamos si hay una sesión previa en el SessionStorage o generamos una nueva
        let sessionKey: number;
        if (sessionStorage.getItem(SESSION_VAR)) {
            sessionKey = parseInt(sessionStorage.getItem(SESSION_VAR) ?? '0');
        } else {
            sessionKey = Math.floor(Math.random() * 1000);
            sessionStorage.setItem(SESSION_VAR, `${sessionKey}`);
        }
        return new TestSession(sessionKey);
    }

    /* INSTANCE */
    private constructor(private readonly _value: number) {
    }

    public get value(): number {
        return this._value;
    }
}
